<script>
  // Public, retro desktop hit counter (ADR 004 Tier-2 retro zone). Shows the
  // aggregate visit count as a classic odometer. Clicking flips the caption.
  // Strictly public-safe: it only ever reads the aggregate /radar/count value —
  // no per-visit or admin data. Respects prefers-reduced-motion.
  import { onMount } from 'svelte';
  import { radar } from '../../os/api.svelte.js';
  import { odometerDigits, visitLabel, onlineLabel } from './hit-counter.js';

  let count = $state(0);
  let loaded = $state(false);
  let flipped = $state(false);

  const digits = $derived(odometerDigits(count));
  const caption = $derived(flipped ? onlineLabel(count) : visitLabel(count));

  async function refresh() {
    const res = await radar.count();
    if (res && typeof res.count === 'number') {
      count = res.count;
      loaded = true;
    }
  }

  onMount(() => {
    refresh();
    const timer = setInterval(refresh, 60_000);
    return () => clearInterval(timer);
  });
</script>

{#if loaded}
  <button
    class="hit-counter"
    type="button"
    onclick={() => (flipped = !flipped)}
    aria-label={caption}
    title={caption}
  >
    <span class="odometer" aria-hidden="true">
      {#each digits as d, i (i)}
        <span class="digit">{d}</span>
      {/each}
    </span>
    <span class="caption">{caption}</span>
  </button>
{/if}

<style>
  .hit-counter {
    position: absolute;
    bottom: 92px;
    right: 16px;
    z-index: 5;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 6px 8px 5px;
    border: 1px solid rgba(0, 0, 0, 0.55);
    border-radius: 6px;
    background: linear-gradient(180deg, #2a2a2a, #141414);
    box-shadow:
      0 1px 3px rgba(0, 0, 0, 0.4),
      inset 0 1px 0 rgba(255, 255, 255, 0.06);
    cursor: pointer;
    font-family: var(--font, sans-serif);
  }
  .hit-counter:hover {
    border-color: rgba(0, 0, 0, 0.75);
  }
  .hit-counter:focus-visible {
    outline: 2px solid #7fb4ff;
    outline-offset: 2px;
  }
  .odometer {
    display: inline-flex;
    gap: 2px;
  }
  .digit {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 15px;
    height: 22px;
    border-radius: 2px;
    background: linear-gradient(180deg, #101a10, #0a120a);
    color: #4be37a;
    font-family: 'Courier New', monospace;
    font-size: 15px;
    font-weight: 700;
    text-shadow: 0 0 4px rgba(75, 227, 122, 0.6);
    box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.8);
    transition: color 0.4s ease;
  }
  .caption {
    font-size: 9px;
    letter-spacing: 0.02em;
    color: #b8b8b8;
    text-transform: uppercase;
  }
  @media (prefers-reduced-motion: reduce) {
    .digit {
      transition: none;
    }
  }
</style>
